import RunTask from './run-task';

/**
 * This is a demo component to show case
 * long running tasks in Node
 */
export default RunTask;
